import { makeAutoObservable } from 'mobx';

import { FilterStore } from '../../shared/util-stores';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import {
  PaymentIssueFilters,
  PaymentIssueFilterValues,
  PaymentIssueSortField,
} from '../interfaces/PaymentIssueFilters';
import { PaymentIssueInfo } from '../interfaces/PaymentIssueRowInfo';
import { requiredAttentionService } from '../services/requiredAttentionService';

class PaymentIssueStore {
  paymentIssues: PaymentIssueInfo[] = [];
  filterMethods: FilterStore<PaymentIssueFilterValues, PaymentIssueSortField>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<PaymentIssueFilterValues, PaymentIssueSortField>(
      this.handleGetPaymentIssues,
    );
  }

  setDefaultValues() {
    this.paymentIssues = [];
    this.filterMethods.setDefaultValues();
  }

  getPaymentIssues(defaultValues: PaymentIssueFilterValues) {
    return this.filterMethods.applyFilters(defaultValues);
  }

  private async handleGetPaymentIssues(filterInfo: PaymentIssueFilters) {
    const response = await requiredAttentionService.getPaymentIssues(filterInfo);

    this.setPaymentIssues(response.content);

    return response;
  }

  private setPaymentIssues(paymentIssues: PaymentIssueInfo[]) {
    this.paymentIssues = paymentIssues;
  }
}

const paymentIssueStore = new PaymentIssueStore();
resetAllStore.addResetMethod(paymentIssueStore.setDefaultValues);

export { paymentIssueStore, PaymentIssueStore };
